import { render, staticRenderFns } from "./LayoutGridOverview.vue?vue&type=template&id=518455e0&"
var script = {}
import style0 from "./LayoutGridOverview.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports